import React, { FC }  from 'react';
import ActiveFilters from '../../components/common/active_filters';
import ReviewFilters from '../../components/reviews/review_list_filters/review_filters';
import CsvExport, { DisplayType } from '../../components/csv_export/csv_export';
import { formatFileNameForCsvExport } from '../../utils/file';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FilterButton } from '../../components/common/filter_button';
import FilterMatrix from '../../modules/filter_matrix';

interface IProps {
    applyFilter: (key: string, value: any, refreshData?: boolean) => void;
    applyReviewScoreFilters?: () => void
    busy: boolean;
    filterMatrix: FilterMatrix;
    getReviewData: any;
    pageLimit: number;
    pageOffset: number;
    pluralNoun: string;
    published: boolean;
    resetFilters: () => void;
    singularNoun: string;
    startExport: any;
    totalFilteredReviewCount: number;
    totalReviewCount: number;
}


const ReviewFiltersTemplate: FC<IProps> = ({
    applyFilter,
    applyReviewScoreFilters,
    busy,
    filterMatrix,
    getReviewData,
    pageLimit,
    pageOffset,
    pluralNoun,
    published = true,
    resetFilters,
    singularNoun,
    startExport,
    totalFilteredReviewCount,
    totalReviewCount,
}: any) => {
    return (
        <div>
        <input type="checkbox" className="hidden peer/filters" id="filters" />
        <div className="hidden peer-checked/filters:block relative ring-1 ring-brand_grey rounded-xl p-3 sm:p-4 bg-brand_faint-blue mb-4 sm:mb-6 md:mb-8 lg:mb-10">
            <div className="flex items-center mb-6">
                <strong className="text-lg md:text-xl">
                    Filter Results
                </strong>
                <button
                    className="ms-4 btn btn-outline btn-outline-tertiary btn-small flex items-center text-md"
                    onClick={resetFilters}
                >
                    <FontAwesomeIcon icon={faXmark} className="me-1" />Clear all filters
                </button>
                <label htmlFor="filters" className="ms-auto cursor-pointer rounded-full bg-brand_tertiary hover:bg-brand_tertiary-dark text-white w-8 h-8 flex justify-center items-center">
                    <FontAwesomeIcon icon={faXmark} />
                </label>
            </div>
            <ReviewFilters
                filterMatrix={filterMatrix}
                applyFilter={applyFilter}
                refreshData={getReviewData}
                published={published}
                applyReviewScoreFilters={applyReviewScoreFilters}
            />
        </div>
        <div className="flex flex-col items-center text-center gap-3 md:flex-row md:text-start">
            <ActiveFilters 
                filterMatrices={[filterMatrix]} 
                totalFilteredSize={totalFilteredReviewCount}
                totalSize={totalReviewCount}
                isLoading={busy}
                pageOffset={pageOffset}
                pageLimit={pageLimit}
                singularNoun={singularNoun}
                pluralNoun={pluralNoun}
                showTotals={true}
                applyFilter={applyFilter}
                showResetLink={true}
                refreshData={getReviewData}
            />
            <div className="md:ms-auto flex flex-wrap justify-center md:justify-end gap-3 lg:flex-nowrap">
                <FilterButton />
                <CsvExport 
                    startExportFunction={startExport}
                    modalTitleSuffix={'Reviews'}
                    label="Export as CSV"
                    displayType={DisplayType.Button}
                    fileName={`${formatFileNameForCsvExport('review_export')}`}
                />
            </div>
        </div>
    </div>
    );
};

export { ReviewFiltersTemplate };